import { render, staticRenderFns } from "./ReconcileHero.vue?vue&type=template&id=bb6ce15c"
import script from "./ReconcileHero.vue?vue&type=script&lang=js"
export * from "./ReconcileHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports